<template>
	<iframe
		v-if="iframeSrc"
		ref="$frame"
		class="angular-frame"
		:src="iframeSrc"
		title="Angular page"
		@load="sayHelloToAngular"
	></iframe>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue"
import { useRoute } from "vue-router"
import { authStore } from "@/store/login"
import { loadSession } from "@/composables/useSession"
import { registerAngularFrame, sayHelloToAngular, unregisterAngularFrame } from "@/utils/angularEmbed"

const route = useRoute()
const auth = authStore()

const $frame = ref<HTMLIFrameElement | null>(null)

onMounted(() => registerAngularFrame($frame))
onUnmounted(() => unregisterAngularFrame($frame))

const ANGULAR_URL = process.env.VUE_APP_ANGULAR_URL || ""

const iframeSrc = computed(() => {
	const angularPath = String((route.meta as Record<string, unknown>).angularPath ?? "")
	if (!angularPath || !ANGULAR_URL) return ""

	const session = loadSession()
	const token = String(auth.jwtToken ?? session?.jwtToken ?? "")
	const sessionKey = String(auth.sessionKey ?? session?.sessionKey ?? "")
	const userId = String(auth.currentUserId ?? session?.id ?? "")

	if (!token || !sessionKey || !userId) {
		return ""
	}

	const params = new URLSearchParams({
		token: token,
		sessionKey: sessionKey,
		userId: userId,
		embedded: "true",
	})
	return `${ANGULAR_URL}/${angularPath}?${params.toString()}`
})
</script>

<style scoped>
.angular-frame {
	width: 100%;
	height: 100%;
	border: none;
	display: block;
}
</style>
